/* eslint-disable camelcase */

import LinkLookup from 'components/LinkLookup';
import pluralize from 'pluralize';
import React from 'react';
import type { User } from 'types';

type ComponentProps = {
  user: User;
};

const AdditionalUserTableRow: React.FC<ComponentProps> = ({ user }) => {
  const onRiskMessages = user.on_risk_count || 0;

  return (
    <tr key={user.uuid} className="table-wrapper__new-tr table-row align-top">
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex flex-col text-body">
          <div className="w-full pl-2 flex flex-row justify-between">
            <span className="truncate">{user.name}</span>
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex flex-col text-body">
          <div className="w-full truncate">{user.email}</div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex flex-col text-body">
          <div className="w-full truncate">{user.email?.split('@')[1]}</div>
        </div>
      </td>

      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex flex-col text-body">
          <LinkLookup
            routeName="envelope-list"
            queryParams={{
              envelopes__filters_search: `~recipients{${user.email}}`,
              envelopes__has_events: 'true',
            }}
            className="w-full truncate text-litlingo-primary underline"
          >
            {onRiskMessages} {pluralize('message', onRiskMessages)}
          </LinkLookup>
        </div>
      </td>
    </tr>
  );
};

export default AdditionalUserTableRow;
